import styled from "styled-components";
import { fontSizes, spacing, typographyMixin } from "@magicbi/ui-library";

/* Design F20: a compact sheet; sections flow into balanced columns so the sheet stays short. */
export const Sections = styled.div<{ $columns?: 1 | 2 }>`
  column-count: ${({ $columns }) => $columns ?? 1};
  column-gap: ${spacing[7]};
`;

export const Section = styled.section`
  display: grid;
  gap: ${spacing[0.5]};
  break-inside: avoid;
  margin-bottom: ${spacing[3]};
`;

/* GAP: design group label is 10px / 700 / .1em; no token. */
export const SectionTitle = styled.h3`
  margin: 0;
  padding: 0 0 ${spacing[1.5]};
  font-size: 0.625rem;
  font-weight: 700;
  line-height: ${spacing[4]};
  text-transform: uppercase;
  letter-spacing: 0.1em;
  color: ${({ theme }) => theme.colors.text.secondary};
`;

export const Rows = styled.dl`
  display: grid;
  margin: 0;
`;

/* A row whose key chips don't fit beside the label drops the chips to a second line, never over the label. */
export const Row = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: ${spacing[1]} ${spacing[4]};
  min-height: ${spacing[8]};
  padding: ${spacing[1]} 0;
  border-bottom: 1px solid ${({ theme }) => theme.colors.border.subtle};

  &:last-child {
    border-bottom: 0;
  }
`;

export const RowLabel = styled.dt<{ $muted?: boolean }>`
  flex: 1 1 8rem;
  min-width: 0;
  margin: 0;
  overflow-wrap: break-word;
  font-size: ${fontSizes["caption-4"]};
  line-height: ${spacing[4]};
  color: ${({ theme, $muted }) => ($muted ? theme.colors.text.tertiary : theme.colors.text.primary)};
`;

export const RowKeys = styled.dd`
  display: inline-flex;
  flex: 0 0 auto;
  flex-wrap: wrap;
  justify-content: flex-end;
  align-items: center;
  gap: ${spacing[2]};
  margin: 0 0 0 auto;
`;

export const Empty = styled.p`
  margin: 0;
  ${typographyMixin("body", 4)}
  color: ${({ theme }) => theme.colors.text.secondary};
`;

/** Label on the left, switch on the right. */
export const Setting = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${spacing[4]};
  width: 100%;
`;

export const SettingText = styled.div`
  position: relative;
  display: grid;
  min-width: 0;
`;

export const SettingLabel = styled.label`
  font-size: ${fontSizes["caption-4"]};
  color: ${({ theme }) => theme.colors.text.primary};
`;

/** Read out as the switch's description, hidden from view. */
export const SettingDescription = styled.span`
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0 0 0 0);
  white-space: nowrap;
  border: 0;
`;

/** The dot between the two key sets of a paired row. */
export const PairDot = styled.span`
  color: ${({ theme }) => theme.colors.text.tertiary};
`;
